import {Dimensions, StyleSheet} from 'react-native';
import {colorPalette, defaultTheme, textStyles} from '../../../../../theme';

export default StyleSheet.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    alignSelf: 'flex-end',
    width: '100%',
    paddingHorizontal: 8,
  },
  backButton: {
    marginVertical: 16,
    marginzleft: 20,
    alignSelf: 'flex-end',
    marginRight: 'auto',
  },
  screenTitle: {
    fontFamily: textStyles.regular,
    fontSize: 18,
    color: colorPalette.grey8_5,
    marginRight: 8,
  },
  title: {marginTop: 24, marginHorizontal: 0, marginHorizontal: 32},
  button: {
    marginTop: 40,
    marginBottom: 20,
    marginHorizontal: 16,
  },
  container: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'flex-end',
    alignItems: 'center',
    zIndex: 100,
    backgroundColor: 'rgba(0,0,0,0.3)',
    zIndex: 0,
    position: 'absolute',
  },
  inputBackGround: {
    backgroundColor: '#fff',
    width: '100%',
    height: 345,
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
  },
  content: {
    backgroundColor: defaultTheme.colors.whiteGrey0,
    width: Dimensions.get('window').width,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    zIndex: 1000,
    position: 'absolute',
    bottom: 0,
  },
  indicator: {
    backgroundColor: colorPalette.secondaryLighter2,
    height: 2,
    width: 36,
    marginTop: 10,
    marginBottom: 4,
    alignSelf: 'center',
  },
  input: {
    flex: undefined,
    height: 164,
    lineHeight: 25,
  },
  inputContainer: {
    marginHorizontal: 16,
  },
  inputArea: {
    height: 164,
  },
});
